module.exports = __webpack_public_path__ + "static/media/mediterraneancouscousbowls.f7838906.jpg";